export default {
    "de": [
        "Bei mir liegt aktuell keine Erkältungskrankheit mit Fieber vor.",
        "Ich hatte in den letzten 14 Tagen keinen wissentlichen Kontakt mit einer Person, bei der das neuartige Corona-Virus (SARS-CoV-2) nachgewiesen wurde.",
        "Ich habe mich in den letzten 14 Tagen in keinem vom Robert-Koch-Institut festgelegten Risikogebiet aufgehalten.\n",
        "Hiermit bestätige ich, dass die oben aufgeführten Angaben wahr und richtig sind. Ich bin mir bewusst, dass falsche Angaben erhebliche Auswirkungen auf die öffentliche Gesundheitssituation haben können.\n",
    ],
    "en": [
        "I currently have no cold with fever.",
        "I have had no knowing contact with any person in the past 14 days the novel corona virus (SARS-CoV-2) has been detected.",
        "I have not been in a risk area specified by the Robert Koch Institute in the past 14 days.",
        "I hereby confirm that the information above is true and correct. I am aware that incorrect information can have a significant impact on the public health situation."
    ]


}
